import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.regexp.split";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import { EventBus } from '@/services/eventbus.js';
import MapViewMixin from '@/components/core/dtwin/map/viewMixin';
export default {
  name: 'ViewPublicMap',
  mixins: [MapViewMixin],
  data: function data() {
    return {
      apiKeyError: false,
      apiKey: null,
      twinId: null,
      hideBottomBar: false,
      clusterDistance: 50,
      footerData: {
        de: {},
        en: {}
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    showBottomBar: function showBottomBar() {
      if (this.hideBottomBar) {
        return false;
      }

      return this.floorList.length > 0 || this.buildingFloorList && this.buildingFloorList.length > 0;
    }
  }),
  watch: {
    $route: function $route() {
      this.clusterDistance = this.getIntFromQueryParam('clusterdistance', 50);
      this.enableZoomLock = this.calcBoolQueryParam('zoomlock');
      this.hideBottomBar = this.calcBoolQueryParam('hidebar');
    }
  },
  created: function () {
    var _created = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this = this;

      var isShared;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.apiKey = this.$route.params.key;
              this.twinId = this.$route.params.twinId;
              this.clusterDistance = this.getIntFromQueryParam('clusterdistance', 50);
              this.enableZoomLock = this.calcBoolQueryParam('zoomlock');
              this.hideBottomBar = this.calcBoolQueryParam('hidebar');
              ApiService.instance.interceptors.request.use(function (config) {
                config.headers['X-API-Key'] = _this.apiKey;
                return config;
              });
              _context.prev = 6;
              _context.next = 9;
              return this.$store.dispatch('authentication/verify', this.apiKey);

            case 9:
              _context.next = 11;
              return ApiService.digitalTwinIsShared(this, this.twinId).then(function (res) {
                return res.isShared;
              }).catch(function (error) {
                console.error(error);
              });

            case 11:
              isShared = _context.sent;

              if (isShared) {
                _context.next = 14;
                break;
              }

              throw new Error('TWIN_SHARING_NOT_ENABLED');

            case 14:
              if (this.$store.state.app.permissions) {
                _context.next = 17;
                break;
              }

              _context.next = 17;
              return this.$store.dispatch('app/loadPermissions');

            case 17:
              EventBus.$emit('refresh-branding');
              _context.next = 23;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](6);
              this.apiKeyError = true;

            case 23:
              if (!this.apiKeyError) {
                this.loadInitialData();
              } // Get Footer Data for Datenschutzhinweis and Impress


              this.footerData = this.$store.state.app.footer;

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[6, 20]]);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    calcBoolQueryParam: function calcBoolQueryParam() {
      var paramName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'zoomlock';
      var queryParams = (window.location.href || '').split('?');

      if (queryParams.length >= 2) {
        return queryParams[1].split('&').findIndex(function (v) {
          return new RegExp("(^".concat(paramName, "(=true|$))"), 'gi').exec(v) !== null;
        }) >= 0;
      }

      return false;
    },
    fetchTwinData: function fetchTwinData() {
      var _this2 = this;

      this.hasLoadedInitially = false;

      if (this.$refs.mapInstance) {
        this.$refs.mapInstance.hasLoadedMarkers = false;
      }

      this.loadTree();
      var selectedRootTwinId = this.$route.params.twinId ? parseInt(this.$route.params.twinId) : null;
      return ApiService.digitalTwinFetchGeoMetaInfos(this, selectedRootTwinId).then(function (data) {
        _this2.stateKeys = data.keyList;
        _this2.twinTags = data.tagList;
        _this2.floorList = data.floorList;
      }).catch(function (error) {
        console.error('Error loading map-twin-state-keys', error);
      });
    },
    getClusterContent: function getClusterContent(cluster, bounds) {
      var _this3 = this;

      if (!cluster) {
        this.selectedCluster = {};
        return;
      }

      var selectedRootTwinId = this.$route.params.twinId ? parseInt(this.$route.params.twinId) : null; // forward-compatability; new API only has search-items and no designated tag-filter

      var searchItems = [this.selectedTwinTag ? {
        variable: 'tag',
        search: this.selectedTwinTag
      } : undefined];
      ApiService.digitalTwinGetGeoClusterContent(this, cluster.id, selectedRootTwinId, this.indoorFloorDtwinId, [[bounds['_ne'].lng, bounds['_ne'].lat], [bounds['_sw'].lng, bounds['_sw'].lat]], [], // filters
      searchItems, this.excludeZones, this.clusterDistance).then(function (data) {
        _this3.selectedCluster = _objectSpread(_objectSpread({}, cluster), {}, {
          items: data.dtwins
        });
      }).catch(function (error) {
        console.error('Error loading map-twin-clusters', error);
      });
    },
    loadTree: function loadTree() {
      var _this4 = this;

      var bounds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      var selectedRootTwinId = this.$route.params.twinId ? parseInt(this.$route.params.twinId) : null; // forward-compatability; new API only has search-items and no designated tag-filter

      var searchItems = this.selectedTwinTag ? [{
        variable: 'tag',
        search: this.selectedTwinTag
      }] : [];
      return ApiService.digitalTwinFetchGeoClusters(this, selectedRootTwinId, this.indoorFloorDtwinId, bounds, this.selectedStateKey, searchItems, {
        excludeZones: this.excludeZones,
        hideStatelessPolygons: this.hideStatelessPolygons,
        clusterDistance: this.clusterDistance
      }).then(function (data) {
        _this4.calculateBoundingBox(data);

        _this4.markerItems = data.dtwins;
      }).catch(function (error) {
        console.error('Error loading map-twin-clusters', error);
      }).finally(function () {
        _this4.$store.state.app.loading = false;
      });
    }
  }
};